export default __webpack_public_path__ + "static/media/fileUploaded.85514c47.svg";